/**
 * Created by minimus on 26.07.2015.
 */
(function($) {
  const path = ajaxurl;
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;

  $(document).ready(function() {
    let lis;
    const dm = ej.DataManager({
      url: `${path}?action=list_adverts&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmChild = ej.DataManager({
      url: `${path}?action=list_adverts_ads&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const grid = $('#grid').ejGrid({
      dataSource: dm,
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      allowFiltering: true,
      filterSettings: {filterType: 'menu'},
      pageSettings: {pageSize: options.itemsPerPage},
      allowSorting: true,
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
      toolbarSettings: {
        showToolbar: true,
        customToolbarItems: [
          'Expand',
          'Collapse',
          'Refresh',
          'Stats',
          'SendMail'
        ]
      },
      columns: [
        {field: 'owner', headerText: localeStrings.advertiser, isPrimaryKey: true},
        {field: 'owner_name', headerText: localeStrings.display}
      ],
      actionComplete: function (args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        li = $('#grid_Stats');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_TestPage');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_SendMail');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function (args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#grid_Stats');
        $tb.ejToolbar(action, li);
        li = $('#grid_TestPage');
        $tb.ejToolbar(action, li);
        li = $('#grid_SendMail');
        $tb.ejToolbar(action, li);
      },
      rowSelected: function (args) {
        $('#owner').val(args.data.owner);
        $('#mail_to').val(args.data.owner);
      },
      toolbarClick: function (args) {
        const tbarObj = $(args.target);
        const rec = this.getSelectedRecords();
        if (tbarObj.hasClass("Expand"))
          this.expandAll();
        else if (tbarObj.hasClass("Collapse"))
          this.collapseAll();
        else if (tbarObj.hasClass("Refresh")) {
          this.refreshContent();
          $('#owner').val('');
          $('#mail_to').val('');
        }
        else if (tbarObj.hasClass('Stats')) {
          const owner = $('#owner').val();
          if ((rec.length !== 0) && ('undefined' !== typeof owner) && (owner !== '')) {
            document.getElementById("stats").submit();
          }
        }
        else if (tbarObj.hasClass('SendMail')) {
          const mailTo = $('#mail_to').val();
          if ((rec.length !== 0) && ('undefined' !== typeof mailTo) && (mailTo !== '')) {
            document.getElementById("send_mail").submit();
          }
        }
      },
      create: function (args) {
        const $toolbar = $('#grid_toolbarItems');
        lis = $toolbar.find("li");
        $('.Expand').parent('li').attr('title', localeStrings.expand);
        $('.Collapse').parent('li').attr('title', localeStrings.collapse);
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
        $('.Stats').parent('li').attr('title', localeStrings.statistics);
        $('.SendMail').parent('li').attr('title', localeStrings.sendMail);
      },
      childGrid: {
        dataSource: dmChild,
        locale: ejLocale,
        queryString: 'owner',
        allowTextWrap: true,
        allowSorting: true,
        allowSelection: true,
        selectionType: ej.Grid.SelectionType.Single,
        selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
        columns: [
          {field: 'owner', isPrimaryKey: true, visible: false},
          {field: 'aid', headerText: localeStrings.adId, textAlign: ej.TextAlign.Right, width: 100},
          {field: 'title', headerText: localeStrings.name, allowEditing: false, width: 250},
          {field: 'description', headerText: localeStrings.desc},
          {field: 'asize', headerText: localeStrings.size, width: 200},
          {field: 'status', headerText: localeStrings.status, textAlign: ej.TextAlign.Center, width: 100}
        ]
      }
    }).data('ejGrid');
  });
})(jQuery);